import LoginForm from './LoginForm';
import { Link } from 'react-router-dom';

import Logo from '../../ui/components/Logo';
import { CustomButton } from '../../utils/Button';

const Login = () => {
  return (
    <>
      <div className="flex flex-col md:flex-row min-h-screen ">
        <div className="hidden bg-[var(--yellow-primary)] w-full md:w-1/3  p-8 lg:flex flex-col py-8">
          <div className="space-y-4">
            <p className=" text-4xl font-normal">Your needs can’t wait</p>
            <p className=" text-5xl font-normal">Meet them on</p>
            <p className=" lg:text-5xl xl:text-7xl font-bold">SmallSmall</p>
          </div>
          <div className="mt-8  lg:h-[357px] lg:w-[355px]">
            <img
              src="/images/login-img.svg"
              alt=""
              className="w-full lg:h-full md:w-2/3 xl:w-full"
            />
          </div>
        </div>

        <div className="flex-1 py-6  px-5 flex flex-col items-center w-[100%] 2xl:w-full mx-auto lg:w-2/3 lg:pl-36">
          <div className="w-full ">
            <div className=" flex justify-center mb-10 lg:mb-5 text-center w-full  lg:justify-end lg:pr-8">
              <Logo />
            </div>

            <div className="mb-4 text-center">
              <h1 className="text-2xl font-semibold mb-2 lg:text-start ">
                Login
              </h1>

              <p className="text-sm hidden md:flex lg:justify-start md:justify-center">
                Please enter your email and password to continue
              </p>
              <p className="md:hidden text-sm flex justify-center  ">
                New to SmallSmall?
                <Link to="/sign-up" className="inline-block underline pl-1">
                  Create account
                </Link>
              </p>
            </div>

            <div className="flex justify-center lg:justify-start">
              <LoginForm />
            </div>

            <div className="text-center mt-4 flex flex-col justify-center lg:max-w-md lg:justify-start items-center ">
              <p className="text-xs text-gray-600">
                By clicking login, you agree to our
              </p>
              <p className="text-xs">
                <Link to="#" className="text-[#0D6EFD]">
                  Terms of use
                </Link>{' '}
                and{' '}
                <Link to="#" className="text-[#0D6EFD]">
                  privacy policy
                </Link>
              </p>
            </div>

            <div className="hidden lg:grid 2xl:mx-auto justify-cente items-center">
              <hr className="my-3 max-w-md" />

              <div className="text-center grid gap-2 max-w-md lg:mx-aut">
                <p className="text-sm">New to SmallSmall?</p>
                <Link to="/sign-up" className="inline-block">
                  <CustomButton
                    text="Create account"
                    bgColor="#FFF8CF"
                    hoverColor="#FACC15"
                    width="100%"
                    textSize="1.125rem"
                    fontWeight="700"
                    borderRadius="40px"
                    className="text-center py-3 mt-2 text-black hover:bg-yellow-400"
                  />
                </Link>
              </div>
            </div>

            <div className="mt-8 grid justify-items-center lg:hidden">
              <img
                src="/images/login-img.svg"
                alt=""
                className="h-[144px] w-[145px] mb-10"
              />
              <p className="text-lg font-normal">Your needs can’t wait</p>
              <p className="text-3xl font-normal">Meet them on</p>
              <p className="text-2xl xl:text-3xl font-bold">SmallSmall</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
